var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{style:(_vm.sizeobject),attrs:{"id":"webcam","autoplay":"","playsinline":"","width":"600","height":"480"}}),_c('canvas',{staticClass:"d-none",attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }